import React, { useState } from 'react';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import { CommonButton } from '../../../../Styles/CommonStyles';
import { useUpdateassetReqMutation } from '../../../../features/assetrequest/assetReqApiSlice';
import nameStringFn from '../../../../data/nameStringFn';
import { useUpdateMultipleDocsMutation } from '../../../../features/addassets/addassetfinalApiSlice';
import { useModifyArrayUserMutation } from '../../../../features/users/usersApiSlice';
import { useAddNewTransactionMutation } from '../../../../features/transactions/transactionsApiSlice';

// Styled Components
const Button = styled(CommonButton)`
  padding: 8px 16px;
  min-width: 120px;
  margin-right: 10px;
`;

const ApproveButton = styled(Button)`
  background-color: #4caf50;
`;

const RejectButton = styled(Button)`
  background-color: #f44336;
`;

const ReturnButton = styled(Button)`
  background-color: #ff9800;
`;

const ForwardButton = styled(Button)`
  background-color: #2196f3;
`;

const RemarkContainer = styled.div`
  margin-top: 15px;
  width: 100%;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  align-self: flex-start;
`;

const BoReturnInboxForm = ({ 
  row, 
  remark, 
  setRemark,
  auth,
  user_current_office,
  getSingleuser,
  handleBack,
  BO_id,
  StoreL1_id,
  UnitHead_id
}) => {
  const [updateReq, { isLoading: updateLoading }] = useUpdateassetReqMutation();
  const [addTrans] = useAddNewTransactionMutation();
  const [modifyArrayUser] = useModifyArrayUserMutation();
  const [updateMultipleAssetDocs] = useUpdateMultipleDocsMutation();

  // Check if this is a Store via BO request
  const isStoreViaBoRequest = row?.req_type === "Asset_Return_Store_Via_BO";

  const handleApproveReturn = async () => {
    if (!remark.trim()) {
      alert("Please provide a remark before approving");
      return;
    }

    // Create data required for transaction
    const transacData = {
      transac_id: row?.uniqueReqId,
      req_id: "",
      asset_id: row?.assets_requested?.[row.assets_requested.length - 1]?.data?.map(x => x.id) || [],
      transac_type: row?.req_type === "Asset_Return_Bo"? "assetReturnBO": "indAssetReturnBo",
      indi_asset: row?.req_type === "Asset_Return_Bo"? false: true,
      from_userid: getSingleuser?.[BO_id]?.email ,
      from_office: user_current_office,
      from_desig: getSingleuser?.[BO_id]?.designation?.[user_current_office] || "",
      from_store: row?.req_store,
      to_userid: getSingleuser?.[row?.req_creator_id]?.email,
      to_office: user_current_office,
      to_desig: row?.req_data[0]?.sent_by?.designation,
      to_store: row?.req_store,
      pdfPath: "",
      time_stamp: new Date().toISOString()
    };

    let senttoData = {
      sent_to_tag: "bo_return_req_approved",
      Text: remark,
      action: "Return Request Approved by BO",
      sent_by: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      sent_to: { id: row?.req_creator_id, name: getSingleuser?.[row?.req_creator_id]?.name, office: row?.req_data[0]?.sent_by?.office, designation: row?.req_data[0]?.sent_by?.designation },
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[row?.req_creator_id])}-${row?.req_data[0]?.sent_by?.office}-${getSingleuser?.[row?.req_creator_id]?.designation?.[user_current_office] || 'Unknown'}`,
      time_stamp: new Date(),
      curr_status: "Closed"
    };

    const assetBody = {
      "assetIdArray": row?.assets_requested?.[row.assets_requested.length - 1]?.data || [],
      "updates": {
        "in_transit": false,
        "cur_loc": "office",
        "last_trans_date": new Date().toISOString(),
        "alloc_user": auth?.id,
        "cur_user_name": `${getSingleuser?.[auth?.id]?.email} (${nameStringFn(getSingleuser?.[auth?.id])})`
      }
    }

    const userBody = [
      {
        _id: row?.req_creator_id,
        operation: "remove",
        arrayField: row.req_type === "Asset_Return_Bo"? `assets.${user_current_office}`: `indi_assets.${user_current_office}`,
        elements: row?.assets_requested?.[row.assets_requested.length - 1]?.data || []
      },
      {
        _id: auth?.id,
        operation: "add",
        arrayField: `assets.${user_current_office}`,
        elements: row?.assets_requested?.[row.assets_requested.length - 1]?.data || []
      }
    ]  
    
    const body = { id: row?._id, senttoData: senttoData };
    
    try {
      const res = await updateReq(body);
      const res3 = await modifyArrayUser({ modifications: userBody });
      const res4 = await updateMultipleAssetDocs(assetBody);
      const res5 = await addTrans(transacData);
      alert("Return request has been approved.");
      handleBack();
    } catch (error) {
      console.error("Error approving request:", error);
      alert("Error approving request. Please try again.");
    }
  };

  const handleRejectReturn = async () => {
    if (!remark.trim()) {
      alert("Please provide a remark before rejecting");
      return;
    }

    // Create senttoData for rejecting the request
    let senttoData = {
      sent_to_tag: "bo_return_req_rejected", 
      Text: remark,
      action: "Return Request Rejected by BO",
      sent_by: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      sent_to: { id: row?.req_creator_id, name: getSingleuser?.[row?.req_creator_id]?.name, office: row?.req_data[0]?.sent_by?.office, designation: row?.req_data[0]?.sent_by?.designation },
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[row?.req_creator_id])}-${row?.req_data[0]?.sent_by?.office}-${getSingleuser?.[row?.req_creator_id]?.designation?.[user_current_office] || 'Unknown'}`,
      time_stamp: new Date(),
      curr_status: "Rejected"
    };
    
    const body = { id: row?._id, senttoData: senttoData };
    
    try {
      await updateReq(body);
      alert("Return request has been rejected.");
      handleBack();
    } catch (error) {
      console.error("Error rejecting request:", error);
      alert("Error rejecting request. Please try again.");
    }
  };

  const handleReturnToUser = async () => {
    if (!remark.trim()) {
      alert("Please provide a remark before returning to user");
      return;
    }

    // Create senttoData for returning to user
    let senttoData = {
      sent_to_tag: "bo_return_to_user_mod", 
      Text: remark,
      action: "Return Request Sent Back to User for Modification",
      sent_by: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      sent_to: { id: row?.req_creator_id, name: getSingleuser?.[row?.req_creator_id]?.name, office: row?.req_data[0]?.sent_by?.office, designation: row?.req_data[0]?.sent_by?.designation },
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[row?.req_creator_id])}-${row?.req_data[0]?.sent_by?.office}-${getSingleuser?.[row?.req_creator_id]?.designation?.[user_current_office] || 'Unknown'}`,
      time_stamp: new Date()
    };
    
    const body = { id: row?._id, senttoData: senttoData };
    
    try {
      await updateReq(body);
      alert("Return request has been sent back to user for modification.");
      handleBack();
    } catch (error) {
      console.error("Error returning request to user:", error);
      alert("Error returning request to user. Please try again.");
    }
  };

  // New function to handle forwarding assets to unit head
  const handleForwardToUnitHeadForStore = async () => {
    if (!remark.trim()) {
      alert("Please provide a remark before forwarding to store");
      return;
    }

    // Create senttoData for forwarding to unit head
    let senttoData = {
      sent_to_tag: "boreq_fwd_unithead",
      Text: remark,
      action: "Office Asset Return Request Forwarded to Unit Head by BO",
      sent_by: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      sent_to: { id: UnitHead_id, name: getSingleuser?.[UnitHead_id]?.name, office: user_current_office, designation: getSingleuser?.[UnitHead_id]?.designation?.[user_current_office] },
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[UnitHead_id])}-${user_current_office}-${getSingleuser?.[UnitHead_id]?.designation?.[user_current_office]|| 'Unknown'}`,
      time_stamp: new Date(),
    };

    // Update the request to indicate it's now with the unit head
    const body = { id: row?._id, senttoData: senttoData };
    
    try {
      await updateReq(body);
      alert("Return request has been forwarded to store.");
      handleBack();
    } catch (error) {
      console.error("Error forwarding request to store:", error);
      alert("Error forwarding request to store. Please try again.");
    }
  };

  return (
    <>
      <RemarkContainer>
        <TextField
          label="Remarks"
          multiline
          rows={4}
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          fullWidth
        />
      </RemarkContainer>

      <ButtonsWrapper>
        {/* Buttons for BO when handling Store via BO request */}
        {isStoreViaBoRequest && (
          <ForwardButton onClick={handleForwardToUnitHeadForStore}>
            Forward to Unit Head for Store
          </ForwardButton>
        )}
        
        {/* Regular BO buttons for non-Store via BO requests */}
        {!isStoreViaBoRequest && (
          <ApproveButton onClick={handleApproveReturn}>
            Accept Return
          </ApproveButton>
        )}
        
        {/* Return to User button always visible */}
        <ReturnButton onClick={handleReturnToUser}>
          Return to User
        </ReturnButton>
        
        {/* Reject button only for regular BO requests */}
        {!isStoreViaBoRequest && (
          <RejectButton onClick={handleRejectReturn}>
            Reject
          </RejectButton>
        )}
      </ButtonsWrapper>
    </>
  );
};

export default BoReturnInboxForm; 